const SKIP_ONCE_KEY = "resonella.skipTitleOnce";

/**
 * Whether the boot-time title must be suppressed for the current URL: a
 * verification query (`bench` / `notitle` / `notutorial`) or a scene/room
 * deep-link (a shared bookmark opens straight into the scene). The title now
 * shows on every normal load, so there is no once-per-day gate; the one-shot
 * skip after a community / local-load / language reload is handled separately
 * via consumeSkipTitleOnce.
 */
export function shouldSuppressTitle(params: URLSearchParams): boolean {
  if (params.has("bench") || params.has("notitle") || params.has("notutorial")) {
    return true;
  }
  return params.has("scene") || params.has("room");
}

/**
 * Flags that the next boot must skip the title. Set right before the reloads
 * that resume into a specific scene (community open, local slot load, language
 * change) so the visitor lands straight in the app instead of replaying the
 * title. Private-mode sessionStorage failures are swallowed (title shows).
 */
export function markSkipTitleOnce(): void {
  try {
    sessionStorage.setItem(SKIP_ONCE_KEY, "1");
  } catch {
    return;
  }
}

/** Reads and clears the skip-once flag; true when this boot follows such a reload. */
export function consumeSkipTitleOnce(): boolean {
  try {
    if (sessionStorage.getItem(SKIP_ONCE_KEY) === null) {
      return false;
    }
    sessionStorage.removeItem(SKIP_ONCE_KEY);
    return true;
  } catch {
    return false;
  }
}
